import _ from "underscore";

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

class Slider extends Component {
  constructor() {
    super();
    this.state = { active: false };
    _.bindAll(this,
      'activate',
      'deactivate',
      'shiftPercentComplete'
    );
  }

  componentDidMount() {
    window.addEventListener("mouseup", this.deactivate);
    window.addEventListener("mousemove", this.shiftPercentComplete);
    window.addEventListener("mousedown", this.shiftPercentComplete);
  }

  componentWillUnmount() {
    window.removeEventListener("mouseup", this.deactivate);
    window.removeEventListener("mousemove", this.shiftPercentComplete);
    window.removeEventListener("mousedown", this.shiftPercentComplete);
  }

  deactivate() {
    this.setState({ active: false });
  }

  activate() {
    this.setState({ active: true });
  }

  shiftPercentComplete(evt) {
    if (this.state.active) {
      // we want the mousePosition relative to the viewport, not the page (for when browser is scrolled horizontally)
      let mousePosition = evt.clientX;
      let leftLimit = this._leftLimit();
      let rightLimit = (leftLimit + this.props.pixelLength);
      let nextPercentComplete = this._percentComplete(mousePosition, leftLimit, rightLimit);

      this.props.shiftPercentComplete(nextPercentComplete);
    }
  }

  _percentComplete(mousePosition, leftLimit, rightLimit) {
    let percentComplete;

    if (mousePosition < leftLimit) {
      percentComplete = 0;
    } else if (mousePosition > rightLimit) {
      percentComplete = 1;
    } else {
      percentComplete = (mousePosition - leftLimit) / this.props.pixelLength;
    }

    return percentComplete;
  }

  _leftLimit() {
    // eslint-disable-next-line react/no-find-dom-node
    return ReactDOM.findDOMNode(this).getBoundingClientRect().left;
  }

  _widthComplete() {
    return Math.round(this.props.percentComplete * this.props.pixelLength);
  }

  _completeBarWidth() {
    return this._widthComplete() + 'px';
  }

  _thumbOffset() {
    return (this._widthComplete() - 6) + 'px';
  }

  render() {
    return (
      <div className="browser-audio-slider-container" onMouseDown={this.activate} >
        <div className="browser-audio-slider-bar browser-audio-slider-bar-total" style={{ width: this.props.pixelLength + 'px' }} />
        <div className="browser-audio-slider-bar browser-audio-slider-bar-complete" style={{ width: this._completeBarWidth() }} />
        <div className="browser-audio-slider-thumb" style={{ left: this._thumbOffset() }} />
      </div>
    );
  }
}

Slider.propTypes = {
  pixelLength: PropTypes.number.isRequired,
  percentComplete: PropTypes.number.isRequired,
  shiftPercentComplete: PropTypes.func.isRequired
};

export default Slider;
